import { render } from "./SideBarAsideUser.vue?vue&type=template&id=38882f08"
import script from "./SideBarAsideUser.vue?vue&type=script&lang=js"
export * from "./SideBarAsideUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__